import script from "./UIUserHint.vue?vue&type=script&lang=ts&setup=true"
export * from "./UIUserHint.vue?vue&type=script&lang=ts&setup=true"

import "./UIUserHint.vue?vue&type=style&index=0&id=6cc449dd&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src024011243/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cc449dd"]])

export default __exports__